import { ViewType } from 'structure/pv2/dynavault/components/ViewTypeSwitch';
import { VaultListTable } from 'structure/pv2/dynavault/components/VaultListTable';
import { VaultListCards } from './VaultListCards';
import { useClientRenderDelay } from 'utils/hooks/useClientRenderDelay';
import { useVaultListAcrossChains } from 'structure/pv2/dynavault/hooks/useVaultList';
import { useConnection } from 'wagmi';
import { Loader } from '@dapp/multi-lib/ui/loader';
import { useVaultListOnChainDataAcrossChains } from 'structure/pv2/dynavault/hooks/useVaultListBlockchain';
import { useVaultListContext } from 'structure/pv2/dynavault/context/VaultListContext';
import { useMemo } from 'react';
import { matchesVaultStatusFilter } from 'structure/pv2/dynavault/utils/vaultStatus';
import { sortVaultList } from 'structure/pv2/dynavault/utils/sortVaultList';
import { VAULT_LIST_REFETCH_INTERVAL } from 'structure/pv2/dynavault/constants';
import {
  matchesVaultAssetTypeFilter,
  matchesVaultChainFilter,
} from 'structure/pv2/dynavault/utils/vaultFilters';

export const VaultList = () => {
  const {
    viewType,
    vaultStatusFilter,
    vaultChainFilter,
    vaultAssetTypeFilter,
    sort,
  } = useVaultListContext();

  const csr = useClientRenderDelay();
  const vaultListQuery = useVaultListAcrossChains();
  const account = useConnection();

  const filteredVaultList = useMemo(() => {
    return (vaultListQuery.data || []).filter(
      (vault) =>
        matchesVaultStatusFilter(vault, vaultStatusFilter) &&
        matchesVaultChainFilter(vault, vaultChainFilter) &&
        matchesVaultAssetTypeFilter(vault, vaultAssetTypeFilter)
    );
  }, [
    vaultAssetTypeFilter,
    vaultChainFilter,
    vaultListQuery.data,
    vaultStatusFilter,
  ]);

  const onChainDataQuery = useVaultListOnChainDataAcrossChains({
    vaultList: filteredVaultList,
    walletAddress: account.address as `0x${string}`,
    query: {
      staleTime: VAULT_LIST_REFETCH_INTERVAL,
      refetchInterval: VAULT_LIST_REFETCH_INTERVAL,
      enabled: !!filteredVaultList.length,
    },
  });

  const sortedVaultList = useMemo(() => {
    return sortVaultList(filteredVaultList, onChainDataQuery.data ?? {}, sort);
  }, [filteredVaultList, onChainDataQuery.data, sort]);

  if (!csr) {
    return <Loader color='white' />;
  }

  if (vaultListQuery.isLoading) {
    return <Loader color='white' />;
  }

  return (
    <>
      {viewType === ViewType.TABLE ? (
        <VaultListTable vaultList={sortedVaultList} />
      ) : null}
      {viewType === ViewType.CARD ? (
        <VaultListCards
          vaultList={sortedVaultList}
          vaultStatusFilter={vaultStatusFilter}
        />
      ) : null}
    </>
  );
};
